import script from "./DatePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./DatePicker.vue?vue&type=script&lang=ts&setup=true"

import "./DatePicker.vue?vue&type=style&index=0&id=b7c80ae4&lang=scss"

const __exports__ = script;

export default __exports__